import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "Comparator";
var classes = {
    viewer: "".concat(PREFIX, "-viewer"),
    flex: "".concat(PREFIX, "-flex"),
    flexItem: "".concat(PREFIX, "-flexItem"),
    addAnimate: "".concat(PREFIX, "-addAnimate")
};
var StyledComparator = styled(Box)(function () {
    var _a, _b, _c;
    return (_a = {
            "@keyframes addAnimate": {
                from: { transform: "scale(0)", opacity: 0 },
                to: { transform: "scale(1)", opacity: 1 }
            }
        },
        _a["&.".concat(classes.viewer)] = (_b = {
                display: "grid",
                height: "100%",
                width: "100%"
            },
            _b[".".concat(classes.flex)] = (_c = {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "stretch",
                    alignItems: "stretch",
                    gap: "1em"
                },
                _c[".".concat(classes.flexItem)] = {
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: "100px"
                },
                _c),
            _b[".".concat(classes.addAnimate)] = {
                animation: "addAnimate .3s linear"
            },
            _b),
        _a);
});

export { classes, StyledComparator as default };
//# sourceMappingURL=index.styled.js.map
